export default {
  'ADD_NEW': 'Add new',
  'LIBRARY_SECTIONS': 'Sections',
  'MENU_DASHBOARD': 'Dashboard',
  'MENU_DOCUMENT': 'Document',
  'MENU_HOME': 'Home',
  'MENU_LIBRARY': 'Library',
  'MENU_QUOTES': 'Quotes',
  'MENU_REPORTS': 'Reports',
  'MENU_SETTINGS': 'Settings',
  'VIEW_ALL': 'View all'
}



// WEBPACK FOOTER //
// ./src/i18n/gb.js